/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Boiler_Type_Heat_Pump_Cooling_UnitInputs */



/**
* | output |
* | --- |
* | "Heat pump / chiller" |
*
* @param {Boiler_Type_Heat_Pump_Cooling_UnitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const boiler_type_heat_pump_cooling_unit = /** @type {((inputs?: Boiler_Type_Heat_Pump_Cooling_UnitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Boiler_Type_Heat_Pump_Cooling_UnitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Heat pump / chiller")
	return /** @type {LocalizedString} */ ("PAC / groupe froid")
});